import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

const commissionsReducer = (state = initialState.currentOffer.commissions, action) => {
  switch (action.type) {
    case actionTypes.LOAD_COMMISSIONS_STARTED: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          loaded: false,
          loading: true,
          saving: { subsidies: false, commissions: false }
        }
      };
    }

    case actionTypes.SAVE_COMMISSIONS_STARTED: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          saving: { subsidies: action.isSubsidy, commissions: !action.isSubsidy }
        }
      };
    }

    case actionTypes.SAVE_COMMISSIONS_FINISHED: {
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          saving: { subsidies: false, commissions: false }
        }
      };
    }

    case actionTypes.LOAD_COMMISSIONS_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true,
          saving: { subsidies: false, commissions: false }
        }
      };
    }

    case eventTypes.COMMISSIONS_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          loading: false,
          loaded: false,
          saving: { subsidies: false, commissions: false }
        }
      };
    }

    case actionTypes.COMMISSION_COMPUTED: {
      const isSubsidy = action.isSubsidy;
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          computed: { index: action.idx, isSubsidyComputed: isSubsidy, isCommissionComputed: !isSubsidy }
        }
      };
    }

    case actionTypes.COMPUTED_RESET: {
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          computed: { index: -1, isSubsidyComputed: false, isCommissionComputed: false }
        }
      };
    }

    default:
      return state;
  }
};

export default commissionsReducer;
